// extracted by mini-css-extract-plugin
module.exports = {"container":"NewProject_container__3pcKU"};